var map = {
	"./1.png": 68330,
	"./2.png": 9409,
	"./3.png": 88280,
	"./4.png": 10423,
	"./5.png": 10926,
	"./6.png": 38757,
	"./7.png": 86492,
	"./8-old.png": 87475,
	"./8.png": 7883,
	"./9.png": 17378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41800;